angular.module('siter.io').controller 'TutorialCtrl', ["$scope", "$rootScope", "Auth", "$state", "User", "$filter", ($scope, $rootScope, Auth, $state, User, $filter) ->

  stateIsMixer = false
  stateIsSiteEditor = false

  if Editor? and window.Editor?
    stateIsMixer = window.Editor.mode == 'site.page.mixer' || (window.Editor.mode == 'site.page.editor' && window.Editor.option == 'site.page.mixer')
    stateIsSiteEditor = window.Editor.mode == 'site.page.editor' && window.Editor.option != 'site.page.mixer'

  init = ->
    if stateIsMixer
      videos =   [
        {url: "#{$filter('translate')('editor.tutorialMixer.video')}?autoplay=1&rel=0", active: false}
      ]
    else
      videos =   [
        {url: "#{$filter('translate')('editor.tutorial.video1')}?autoplay=1&rel=0", active: false}
        {url: "#{$filter('translate')('editor.tutorial.video2')}?autoplay=1&rel=0", active: false}
        {url: "#{$filter('translate')('editor.tutorial.video3')}?autoplay=1&rel=0", active: false}
      ]

    $scope.videos = []

    for video in videos
      if video.url.indexOf("http") > -1
        $scope.videos.push video

    if $scope.videos.length > 0
      $scope.videos[0].active = true

  init()

  $rootScope.openVideoTutorial = ->
    if stateIsMixer or stateIsSiteEditor
      angular.element('body').addClass 'modal-open'

    $scope.tutorial = {active: true}

  resetActive = ->
    for video in $scope.videos
      video.active = false

  # Next tutorial step

  $scope.nextStep = ->
    activeVideo = _.filter($scope.videos, {active: true})[0]
    index = $scope.videos.indexOf activeVideo
    index++
    if $scope.videos[index]
      resetActive()
      $scope.videos[index].active = true
    else
      resetActive()
      $scope.videos[0].active = true


  $scope.showStep = (step) ->
    resetActive()
    $scope.videos[step].active = true


  # Remove tutorial view

  $scope.closeTutorial = ->
    angular.element('body').removeClass 'modal-open'
    $scope.tutorial.active = false

    if stateIsMixer
      params =
        tutorial_mixer_passed: true
        id: $rootScope.currentUser.id
    else
      params =
        tutorial_passed: true
        id: $rootScope.currentUser.id

    User.save params

  if $rootScope.currentUser?
    tutorialIsNotPassed = !$rootScope.currentUser.tutorial_passed and stateIsSiteEditor
    tutorialMixerIsNotPassed = !$rootScope.currentUser.tutorial_mixer_passed and stateIsMixer

    if $scope.videos.length > 0 and (tutorialIsNotPassed or tutorialMixerIsNotPassed)
      $rootScope.openVideoTutorial()
]



// WEBPACK FOOTER //
// ./src/app/common/controllers/tutorial.controller.coffee